import object from '@mailobj-browser/front/js/utils/object.js'

export const block = 'ea_generics__xaddrs'

export const elements = object(null, {
  add: `${block}_add`,
  add_input: `${block}_add_input`,
  item: `${block}_item`,
  item_content_value: `${block}_item_content_value`,
  loading: `${block}_loading`
})

export const modifiers = object(null, {
  item: object(null, {
    editing: `${elements.item}-editing`,
    loading: `${elements.item}-loading`,
    not_ok: `${elements.item}-not_ok`,
    ok: `${elements.item}-ok`
  })
})
